export const LOOKUP_TABLE_FIELD_TYPE = {
  system: -100,
  text: 1,
  date: 2,
  number: 3,
  checkbox: 4,
  dropdown: 5,
  image: 6,
  lookupTable: 7,
  table: 8,
  computed: 9,
  summary: 11,
  tableSummary: 13,
  hyperlink: 14,
};